// Copyright (c) 2022 by Move Closer

import { PropType } from '@vue/composition-api'

import { ComponentObjectPropsOptions } from '../../vue-api'
import { canHaveThemeProp } from '../../composables'

import { Step, StepsProps } from './Steps.contracts'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const stepsProps: ComponentObjectPropsOptions<StepsProps> = {
  ...canHaveThemeProp,
  /**
   * @see StepsProps.steps
   */
  steps: {
    type: Array as PropType<Step[]>,
    required: true
  }
}
